import { motion } from "framer-motion";

const images = ["/images/img7.jpg", "/images/img2.jpg", "/images/img1.jpg", "/images/img5.jpg", "/images/img6.jpg"];

const InformasiKalia = () => {
  return (
    <section className="relative bg-black text-white py-20 px-4 md:px-10 overflow-hidden">
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-start">
        {/* ================= RIGHT (TEXT) ================= */}
        <motion.div initial={{ opacity: 0, x: 80 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }}>
          <p className="uppercase tracking-[0.3em] text-sm text-pink-400 mb-4">INFORMASI ARTIS</p>

          <h2 className="text-3xl md:text-5xl font-bold leading-tight mb-6">Kalia Siska</h2>

          <p className="text-gray-300 leading-relaxed mb-6">
            Kalia Siska adalah seorang penyanyi dangdut dan DJ kentrung asal Karawang yang dikenal luas melalui berbagai cover lagu yang viral di YouTube. Dengan gaya unik yang memadukan dangdut, ska, dan reggae, ia berhasil menciptakan
            warna musik yang fresh dan mudah diterima berbagai kalangan.
          </p>

          <p className="text-gray-400 leading-relaxed mb-6">
            Nikmati penampilan terbaik Kalia Siska dengan suara khas dan aksi panggung penuh semangat yang selalu menghibur penggemar. Perpaduan dangdut koplo, musik modern, dan gaya fresh menjadikan Kalia Siska salah satu ikon hiburan masa
            kini. Dari lagu viral hingga konser meriah, Kalia Siska hadir membawa hiburan yang seru, meriah, dan berkesan.
          </p>

          <div className="flex flex-wrap gap-3">
            <span className="bg-pink-500/20 text-pink-400 px-4 py-1 rounded-full text-sm">Dangdut</span>
            <span className="bg-green-500/20 text-green-400 px-4 py-1 rounded-full text-sm">Ska Reggae</span>
            <span className="bg-yellow-500/20 text-yellow-400 px-4 py-1 rounded-full text-sm">DJ Kentrung</span>
          </div>
        </motion.div>

        {/* ================= LEFT (IMAGE GRID) ================= */}
        <motion.div initial={{ opacity: 0, x: -80 }} whileInView={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} viewport={{ once: true }} className="grid grid-cols-2 gap-4 auto-rows-[120px] md:auto-rows-[160px]">
          {/* BESAR */}
          <div className="col-span-2 row-span-2 rounded-3xl overflow-hidden">
            <img src={images[0]} alt="" className="w-full h-full object-cover" />
          </div>

          {/* KECIL */}
          <div className="h-full">
            <div className="rounded-2xl overflow-hidden h-full">
              <img src={images[4]} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="rounded-2xl overflow-hidden mt-4 h-full">
              <img src={images[3]} alt="" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* TINGGI */}
          <div className="rounded-2xl overflow-hidden row-span-2">
            <img src={images[2]} alt="" className="w-full h-full object-cover" />
          </div>

          {/* LEBAR */}
          {/* <div className="col-span-2 rounded-2xl overflow-hidden block md:hidden">
            <img src={images[1]} alt="" className="w-full h-full object-cover" />
          </div> */}
        </motion.div>
      </div>
    </section>
  );
};

export default InformasiKalia;
